// src/beta/services/documents.ts
import { betaFetch } from '@/beta/services/api';
import type { V1DocumentSummary, V1DocumentDetail } from '@/beta/types/dossier';

interface ListResp {
  version: 1;
  vehicle_id: string;
  data: { documents: V1DocumentSummary[]; total: number };
  generated_at: string;
}

interface DetailResp {
  version: 1;
  data: V1DocumentDetail;
  generated_at: string;
}

/** GET /v1/vehicles/[id]/documents — thumbnail metadata for the grid. */
export async function listDocuments(vehicleId: string) {
  const res = await betaFetch<ListResp>(`/vehicles/${vehicleId}/documents`);
  return res.data;
}

/** GET /v1/documents/[docId] — full detail with signed file_url for the modal. */
export async function getDocument(docId: string) {
  const res = await betaFetch<DetailResp>(`/documents/${docId}`);
  return res.data;
}
